import type { FC } from "react"
import type { TemplateProps } from "./types"
import { BaseTemplate } from "./BaseTemplate"
import { ModernImpactTemplate } from "./ModernImpactTemplate"
import { ClassicNonprofitTemplate } from "./ClassicNonprofitTemplate"
import { BoldActivistTemplate } from "./BoldActivistTemplate"

const TEMPLATE_MAP: Record<string, FC<TemplateProps>> = {
  "Modern Impact": ModernImpactTemplate,
  "Classic Nonprofit": ClassicNonprofitTemplate,
  "Bold Activist": BoldActivistTemplate,
}

/** Resolve template component by template name. Falls back to BaseTemplate. */
export function getTemplateComponent(templateName: string | null | undefined): FC<TemplateProps> {
  if (templateName && templateName in TEMPLATE_MAP) {
    return TEMPLATE_MAP[templateName]
  }
  return BaseTemplate
}

export { BaseTemplate, ModernImpactTemplate, ClassicNonprofitTemplate, BoldActivistTemplate }
export * from "./types"
